import React from 'react';
import { IBonusToDisplay } from '@core/js/components/main/BonusHistory/types';
import { ITranslateMethod } from '@core/js/hooks/i18n/types';
import style from '../index.scss';

export type GetRenderPopupCellType = {
    showTermsPopup: (event: React.MouseEvent<HTMLElement>, termAndConditionWebContentId: string, title: string) => void;
    translate: ITranslateMethod;
}

export const getRenderPopupCell = ({
    showTermsPopup,
    translate
}: GetRenderPopupCellType) => (name: string, value?: Pick<IBonusToDisplay, 'popupWcId' | 'popupTitle'>): React.ReactNode => {
    if (!value) {
        return null;
    }

    const { popupWcId, popupTitle } = value;

    return (
        <>
            <div className={`${style.cellName} accordionBodyCellName`}>{translate(name)}</div>
            <div className={`accordionBodyCellValue ${style.cellValue}`}>
                <a href="#" className={style.showPopup}
                    onClick={(event) => showTermsPopup(event, popupWcId, popupTitle)}
                >
                    {translate('playtech.mobile.system.bonusDetail.tcRef')}
                </a>
            </div>
        </>
    );
};
